import { CSSProperties } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useCurrentDevice } from "../hooks";
import { LOGIN_ROUTE } from "../routes";
import { formatDateTime } from "../utils";

interface OptionsDropDownProps {
  onLogout: () => void;
  navBarHeightInPx: number;
}

const OptionsDropDown: React.FC<OptionsDropDownProps> = ({
  navBarHeightInPx,
  onLogout,
}) => {
  const { wipeTokenAndRedirect } = useAuth();
  const { isComp } = useCurrentDevice();
  const navigate = useNavigate();
  const COMMIT_HASH = process.env.REACT_APP_COMMIT_HASH || "abcdefg";
  const DEPLOY_DATETIME =
    process.env.REACT_APP_DEPLOY_DATETIME || "2024-10-22T01:53:48Z";
  const COMMIT_MESSAGE =
    process.env.REACT_APP_COMMIT_MESSAGE ||
    "diddley doo, did some things, and maybe some other things (#325)";

  const logout = () => {
    wipeTokenAndRedirect();
    navigate(LOGIN_ROUTE);
    onLogout();
  };

  const widthStyles: CSSProperties = isComp
    ? {
        maxWidth: "200px",
      }
    : { width: "100%" };

  return (
    <div
      style={{
        ...widthStyles,
        position: "absolute" as "absolute",
        top: `${navBarHeightInPx}px`, // Known height of navbar
        right: "0",
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        borderTop: 0,
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        zIndex: 1,
      }}
    >
      <div className="flex flex-col justify between ">
        <div className="text-sm py-4 px-2 flex flex-col gap-2">
          <b>Frontend Version</b>
          <div>#{COMMIT_HASH}</div>
          <div>{formatDateTime(DEPLOY_DATETIME)}</div>
          <div>{COMMIT_MESSAGE}</div>
        </div>
        <div>
          <button
            onClick={logout}
            className="font-bold hover:text-purple-600 py-1 border border-top-1 border-x-0 border-b-0 border-gray-300 w-full"
          >
            Log out
          </button>
        </div>
      </div>
    </div>
  );
};

export default OptionsDropDown;
